import { AlertTriangle } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import { OPS } from "@/constants/testIds";
import { fmt, fmtSar, fmtTime } from "./coUtils";

const C = OPS.co;

/**
 * The 409 `CO_DUPLICATE_INVOICE` card, rendered UNDER the invoice field with
 * the form preserved. «نعم، تسجيل ثانٍ» resends the same `client_request_id`
 * with `confirm_duplicate: true`; the server sets `duplicate_of` itself.
 */
export function DuplicateCard({ detail, onConfirm, onCancel, busy }) {
    const { t, lang } = useI18n();
    const who = detail.mine
        ? t("co_duplicate_mine")
        : (detail.by_name ? fmt(t("co_duplicate_by"), { name: detail.by_name }) : t("co_duplicate_other"));
    return (
        <div data-testid={C.duplicate.card}
             className="space-y-2 rounded-[var(--radius-lg)] border border-[color:var(--warning-soft-fg)]/40 bg-[color:var(--warning-soft)] p-3">
            <div className="flex items-start gap-2">
                <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-[color:var(--warning-soft-fg)]" />
                <div className="min-w-0 flex-1">
                    <p className="text-sm font-bold text-[color:var(--ink)]">{t("co_duplicate_title")}</p>
                    <p className="text-xs text-[color:var(--ink-muted)]">
                        {who} · {t("co_duplicate_at")} {fmtTime(detail.occurred_at, lang)}
                        {detail.value_sar !== null && detail.value_sar !== undefined
                            ? ` · ${t("co_duplicate_value")} ${fmtSar(detail.value_sar, lang, { halalas: false })} ${lang === "ar" ? "ر.س" : "SAR"}`
                            : ""}
                    </p>
                </div>
            </div>
            <div className="flex gap-2">
                <Button data-testid={C.duplicate.confirm} size="sm" onClick={onConfirm} disabled={busy}
                        className="h-10 flex-1 text-xs font-bold">
                    {t("co_duplicate_confirm")}
                </Button>
                <Button data-testid={C.duplicate.cancel} size="sm" variant="outline" onClick={onCancel} disabled={busy}
                        className="h-10 flex-1 text-xs font-bold">
                    {t("co_duplicate_cancel")}
                </Button>
            </div>
        </div>
    );
}
